import React from 'react';
import DashboardIcon from '@atlaskit/icon/core/dashboard';
import { ButtonItem } from '@atlaskit/menu';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const SaveAsTemplateButton = () => {
	const { formatMessage } = useIntl();
	return (
		<ButtonItem
			onClick={() => {
				// TODO analytics
			}}
			iconBefore={<DashboardIcon label="" spacing="spacious" color={token('color.icon')} />}
		>
			{formatMessage(messages.saveAsTemplateNonFinal)}
		</ButtonItem>
	);
};
